// firebase/index
export const firebaseConfig = {
  apiKey: "AIzaSyAsyBBHDDarVoe33XDN_MYRstLJoMqczGU",
  authDomain: "jobfairaruba.firebaseapp.com",
  projectId: "jobfairaruba",
  storageBucket: "jobfairaruba.firebasestorage.app",
  messagingSenderId: "1035090729593",
  appId: "1:1035090729593:web:b2d50d37d66ecac83412a8",
  measurementId: "G-M3281ZYZ6L"
};
// firebase/storage
export const storageUrl =
  "https://firebasestorage.googleapis.com/v0/b/jobfairaruba.appspot.com/o/";
